// src/components/ReportPreview.js
import React, { useEffect, useState } from "react";
import { Card, Spinner, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ReportPreview = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("auth_token");

    fetch("https://loopsneller.com/api/reports", {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch reports");
        }
        return res.json();
      })
      .then((data) => {
        setReports(data.slice(0, 5)); // Show latest 5
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to load reports.");
        setLoading(false);
      });
  }, []);

  if (loading) return <Spinner animation="border" size="sm" />;

  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <strong>Recent Reports</strong>
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => navigate("/reports")}
        >
          View All
        </button>
      </Card.Header>
      <Card.Body>
        {reports.length === 0 ? (
          <p className="text-muted">
            No reports available for your account yet.
          </p>
        ) : (
          <ul className="list-unstyled">
            {reports.map((report) => (
              <li key={report.id} className="mb-2">
                <strong>{report.type}</strong> —{" "}
                {report.project?.name || "No Project"}
                <br />
                <small className="text-muted">
                  Created by {report.user?.name || "Unknown"}
                </small>
              </li>
            ))}
          </ul>
        )}
      </Card.Body>
    </Card>
  );
};

export default ReportPreview;
